export default __webpack_public_path__ + "static/media/3.10422c67.jpg";